///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.notifications = abcsetup.notifications || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.notifications.bellBtn = null;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    abcsetup.notifications.init();
});


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.notifications = {
    init() {
        this.bellBtn = $('.navbar .notifications_toggle')

        this.updateCount();
        this.updateMostRecentList();

        this._bindToggleRead();
        this._bindMarkAllRead();
    },

    hasBellBtn() {
        return this.bellBtn && this.bellBtn.length > 0;
    },

    /**
     * Update the count on the bell button with the most recent unread count.
     */
    updateCount() {
        if (!this.hasBellBtn()) {
            return;
        }

        // We want this is execute silently
        var $silentAjax = abcsetup.performAjaxSilently;
        abcsetup.performAjaxSilently = true;

        axios.get('/api/users/notifications/count').then(({data}) => {
            abcsetup.performAjaxSilently = $silentAjax;
            var value = data.unread_count < 10 ? '&nbsp;' + data.unread_count + '&nbsp;' : data.unread_count;
            this.bellBtn.find('.unread-count').html(value).toggle(data.unread_count > 0);
        });
    },

    /**
     * Update the list of notifications that will display when the bell button is clicked.
     */
    updateMostRecentList() {
        if (!this.hasBellBtn()) {
            return;
        }

        const makeNotificationItem = notification => notification.data.url
            ?   `<a href="/users/notifications/${notification.id}/visit"
                    rel="nofollow noopener"
                    class="list-group-item list-group-item-action d-flex justify-content-between align-items-center ${notification.read_at ? 'read' : ''} notification_item id_${notification.id}">
                    <div>
                        ${notification.data.title ? `<div class="title">${notification.data.title}</div>` : ''}
                        <div class="message">
                            ${notification.data.message}
                        </div>
                        <small class="when">
                            ${moment(notification.created_at).fromNow()}
                        </small>
                    </div>
                    <div class="btn_toggle_read_container">
                        <button type="button" class="btn_toggle_read" title="Mark as ${notification.read_at ? 'unread' : 'read'}"></button>
                    </div>
                </a>`
            :   `<div 
                    class="no-link list-group-item list-group-item-action d-flex justify-content-between align-items-center ${notification.read_at ? 'read' : ''} notification_item id_${notification.id}">
                    <div>
                        ${notification.data.title ? `<div class="title">${notification.data.title}</div>` : ''}
                        <div class="message">
                            ${notification.data.message}
                        </div>
                        <small class="when">
                            ${moment(notification.created_at).fromNow()}
                        </small>
                    </div>
                    <div class="btn_toggle_read_container">
                        <button type="button" class="btn_toggle_read" title="Mark as ${notification.read_at ? 'unread' : 'read'}"></button>
                    </div>
                </div>`

        const makeNotificationsList = (notificationItemsHtml, count) =>
            `<div class="notifications_container">
                <div class="d-flex justify-content-end">
                    ${count > 0 ? `<a href="#" class="p-2 mark_all_as_read_btn">Mark all as read</a>` : ''}
                </div>
                ${count > 0 ? `<ul class="list-group">${notificationItemsHtml}</ul>` : `<div class="alert"><em>You don't have any notifications yet</em></div>`}
                <div class="d-flex justify-content-end">
                    ${count > 0 ? `<a href="/users/notifications" class="p-2">View all</a>` : ''}
                </div>
            </div>`

        axios.get('/api/users/notifications').then(({data}) => {
            const notificationItems = []

            if (data.notifications && Array.isArray(data.notifications)) {
                data.notifications.forEach(notification => {
                    notificationItems.push(makeNotificationItem(notification));
                });

                this.bellBtn.data(
                    'content',
                    makeNotificationsList(notificationItems.join(''), data.notifications.length)
                );
                this._syncPopperHtml();
            }
        });
    },

    /**
     * Mark a notification as read.
     * @param id
     * @returns {Promise}
     */
    markAsRead(id) {
        return axios.put(`/api/users/notifications/${id}/mark-as-read`)
    },

    /**
     * Mark a notification as unread.
     * @param id
     * @returns {Promise}
     */
    markAsUnread(id) {
        return axios.put(`/api/users/notifications/${id}/mark-as-unread`)
    },

    /**
     * Mark a all notifications as read for the authed user's current role.
     * @returns {Promise}
     */
    markAllAsRead() {
        return axios.put(`/api/users/notifications/mark-all-as-read`)
    },

    /**
     * Allow users to toggle items as read in the notifications list in their navbar.
     * @private
     */
    _bindToggleRead() {
        $(document).on('click', '.notifications_container .btn_toggle_read_container', event => {
            event.stopPropagation();
            event.preventDefault();
            const notificationItem = $(event.target).closest('.notification_item');

            if (notificationItem.length === 0) {
                return;
            }

            // Using a class to store the notification ID because I think Popper is stripping out data and custom attributes.
            const idClass = Array.from(notificationItem.get(0).classList.values()).find(i => /^id_/.test(i));

            if (!idClass) {
                return;
            }

            const id = idClass.replace(/^id_/, '');

            if (notificationItem.is('.read')) {
                this.markAsUnread(id).then(() => {
                    notificationItem.removeClass('read');
                    this._syncPopperHtml();
                    this.updateCount();
                });
            } else {
                this.markAsRead(id).then(() => {
                    notificationItem.addClass('read');
                    this._syncPopperHtml();
                    this.updateCount();
                });
            }
        });
    },

    /**
     * Allow users to mark all notifications as read for their currently selected role.
     * @private
     */
    _bindMarkAllRead() {
        $(document).on('click', '.notifications_container .mark_all_as_read_btn', event => {
            event.stopPropagation();
            event.preventDefault();

            this.markAllAsRead().then(() => {
                $('.notifications_container .notification_item').addClass('read');
                this._syncPopperHtml();
                this.updateCount();
            });
        });
    },

    /**
     * When we make alterations in the html in the popover, we use this to update popover's cached version of the HTML in its plugin data.
     * This is also used to set the HTML data in popover if the user opens the notifications list before it has loaded (in that case, popover
     * will cache an empty list and not update it when we build it after the server responds).
     * @private
     */
    _syncPopperHtml() {
        if (!this.bellBtn.data('bs.popover')) {
            // popover hasn't been opened yet, so no need to sync.
            return;
        }

        const $notificationsContainer = $('.notifications_container');
        const contents = $notificationsContainer.length > 0 ? $notificationsContainer.get(0).outerHTML : this.bellBtn.data('content');

        const popoverData = this.bellBtn.data('bs.popover');
        popoverData.config.content = contents;
        this.bellBtn.data('bs.popover', popoverData);
    },
}
